import React, { useState } from "react";
import {
  SafeAreaView,
  ScrollView,
  View,
  Text,
  Image,
  TextInput,
  TouchableOpacity,
  StyleSheet,
} from "react-native";
import AppColors from "../../Constants/AppColors";
import AppFonts from "../../Constants/AppFonts";
import AppImages from "../../Constants/AppImages";
import useAppNavigation from "../../Routes/useAppNavigation";

/**
 * AddDeliveryPerson (mobile view) — mirrors the production /AddDeliveryPerson
 * page: "New Delivery Person Details" + "Vehicle Details" sections.
 * Plain inputs (no native date/dropdown/image deps).
 */
const Input = ({ label, placeholder, secure, multiline }) => {
  const [v, setV] = useState("");
  return (
    <View style={styles.inputWrap}>
      <Text style={styles.label}>{label}</Text>
      <TextInput
        value={v}
        onChangeText={setV}
        placeholder={placeholder}
        placeholderTextColor="#ACACAC"
        secureTextEntry={secure}
        multiline={multiline}
        style={[styles.input, multiline && { height: 76, textAlignVertical: "top" }]}
      />
    </View>
  );
};

const AddDeliveryPerson = () => {
  const navigation = useAppNavigation();
  const [vehicleMode, setVehicleMode] = useState("new"); // new | existing

  return (
    <SafeAreaView style={styles.safe}>
      <View style={styles.header}>
        <TouchableOpacity onPress={() => navigation.goBack()}>
          <Image source={AppImages.Backbtn} style={styles.backIcon} resizeMode="contain" />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>Add Delivery Person</Text>
      </View>

      <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={{ padding: 20 }}>
        <Text style={styles.section}>New Delivery Person Details</Text>
        <Input label="First Name" placeholder="Enter Your First Name" />
        <Input label="Last Name" placeholder="Enter Your Last Name" />
        <Input label="Email" placeholder="Enter Your Email" />
        <Input label="Contact Number" placeholder="Enter Your Contact Number" />
        <Input label="Internal Number" placeholder="Enter Your Internal Number" />
        <Input label="User Password" placeholder="Enter Your Password" secure />
        <Input label="Confirm Password" placeholder="Re-enter Your Password" secure />
        <Input label="Date Of Birth" placeholder="DD-MM-YYYY" />
        <Input label="Joining Date" placeholder="DD-MM-YYYY" />
        <Input label="Gender" placeholder="Select Gender" />
        <Input label="Nationality" placeholder="Select Nationality" />
        <Input label="City" placeholder="Enter City" />
        <Input label="Address" placeholder="Enter Address" multiline />

        <Text style={[styles.section, { marginTop: 8 }]}>Vehicle Details</Text>
        <View style={styles.toggleRow}>
          {["new", "existing"].map((m) => (
            <TouchableOpacity
              key={m}
              style={[styles.toggleBtn, vehicleMode === m && styles.toggleActive]}
              onPress={() => setVehicleMode(m)}
            >
              <Text style={[styles.toggleText, vehicleMode === m && styles.toggleTextActive]}>
                {m === "new" ? "New" : "Existing"}
              </Text>
            </TouchableOpacity>
          ))}
        </View>
        <Input label="Vehicle Number / Name" placeholder="Enter Vehicle Number / Name" />
        <Input label="Registration Number" placeholder="Enter Registration Number" />
        <Input label="Vehicle Category" placeholder="Select Vehicle Category" />
        <Input label="Vehicle Capacity" placeholder="Enter Vehicle Capacity" />
        <Input label="Packets" placeholder="Enter Packets" />

        <View style={styles.actions}>
          <TouchableOpacity style={styles.cancelBtn} onPress={() => navigation.goBack()}>
            <Text style={styles.cancelText}>Cancel</Text>
          </TouchableOpacity>
          <TouchableOpacity style={styles.saveBtn} onPress={() => navigation.goBack()}>
            <Text style={styles.saveText}>Save</Text>
          </TouchableOpacity>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};

export default AddDeliveryPerson;

const styles = StyleSheet.create({
  safe: { flex: 1, backgroundColor: AppColors.white },
  header: {
    width: "100%",
    height: 58,
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 20,
    backgroundColor: AppColors.white,
    shadowColor: "#9C4900",
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 1,
    shadowRadius: 10,
    elevation: 6,
  },
  backIcon: { width: 8, height: 15 },
  headerTitle: {
    color: AppColors.brown1,
    fontSize: 16,
    fontFamily: AppFonts.OverpassMedium,
    marginLeft: 20,
  },
  section: {
    color: AppColors.brown1,
    fontSize: 16,
    fontFamily: AppFonts.OverpassBold,
    marginBottom: 14,
  },
  inputWrap: { marginBottom: 16 },
  label: {
    color: AppColors.brown1,
    fontSize: 13,
    fontFamily: AppFonts.OverpassMedium,
    marginBottom: 6,
  },
  input: {
    borderWidth: 1,
    borderColor: "#ACACAC",
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: 10,
    fontSize: 14,
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown1,
  },
  toggleRow: { flexDirection: "row", marginBottom: 16 },
  toggleBtn: {
    flex: 1,
    borderWidth: 1,
    borderColor: AppColors.brown1,
    paddingVertical: 9,
    alignItems: "center",
  },
  toggleActive: { backgroundColor: AppColors.brown1 },
  toggleText: { color: AppColors.brown1, fontSize: 14, fontFamily: AppFonts.OverpassMedium },
  toggleTextActive: { color: AppColors.white },
  actions: { flexDirection: "row", marginTop: 10, marginBottom: 30 },
  cancelBtn: {
    flex: 1,
    borderWidth: 1,
    borderColor: AppColors.brown1,
    borderRadius: 10,
    paddingVertical: 12,
    alignItems: "center",
    marginRight: 8,
  },
  cancelText: { color: AppColors.brown1, fontSize: 15, fontFamily: AppFonts.OverpassMedium },
  saveBtn: {
    flex: 1,
    backgroundColor: AppColors.brown1,
    borderRadius: 10,
    paddingVertical: 12,
    alignItems: "center",
    marginLeft: 8,
  },
  saveText: { color: AppColors.white, fontSize: 15, fontFamily: AppFonts.OverpassMedium },
});
